import { Component, DestroyRef, inject, ElementRef, HostListener, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormControl } from '@angular/forms';
import {  MatDialog,MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTooltip } from '@angular/material/tooltip';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BaseComponent } from 'src/app/base/base.component';
import { ColoredTextFindReplaceItem } from 'src/app/domainObjects/coloredTextItem';
import { NamedColor } from 'src/app/domainObjects/namedColor';
import { OptionItemDataType } from 'src/app/model/optionItem';
import { ErrorReportingService } from 'src/app/services/errorReporting/error-reporting.service';
import { JsonPasteDialogComponent } from '../json-paste-dialog/json-paste-dialog.component';
import { DelimiterDialogComponent } from '../delimiter-dialog/delimiter-dialog.component';
import { FileUploadDialogComponent } from '../file-upload-dialog/file-upload-dialog.component';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';

export const NamedColorList = [
      new NamedColor('greenyellow', '#CCFF00'),
      new NamedColor('orange', '#FF9933'),
      new NamedColor('pastelblue', '#3399CC'),
      new NamedColor('pastelgreen', '#99FFCC'),
      new NamedColor('purple', '#CC99FF'),
      new NamedColor('turquoise', '#43C6DB'),
      new NamedColor('pink', '#FFC0CB'),
      new NamedColor('blue', '#0099FF'),
      new NamedColor('fuchsia', '#FF00FF'),
      new NamedColor('pastelyellow', '#FFFF99'),
      new NamedColor('grey', '#AB99BB'), 
      new NamedColor('turquoise2', '#26C49B'),
      new NamedColor('pastelred', '#FF3399'),
      new NamedColor('green', '#00FF00'),
      new NamedColor('blue2', '#006080'),
      new NamedColor('red', '#FF5050'),
      new NamedColor('brown', '#CC9900'),
      new NamedColor('lime', '#99FF33'),
      new NamedColor('purple', '#CC00CC'),
      new NamedColor('yelloworange', '#FCEA04'),
      new NamedColor('blue3', '#6666FF'),
      new NamedColor('lightgrey', '#EAEAEA'),
      new NamedColor('hotpink', '#FF66FF'),
      new NamedColor('lightgreen', '#00FF99'),
      new NamedColor('tangerine', '#FF6600'),
      new NamedColor('cyan', '#00FFFF'),
      new NamedColor('yellow', '#FFFF00'),
      new NamedColor('babyblue', '#CCFFFF'),
      new NamedColor('neongreen', '#00CC00'),
      new NamedColor('tan', '#FFCC99'),
  ];
class ViewModel {
  colors: NamedColor[];
  textItems: ColoredTextFindReplaceItem[] = [];
  currentColor: NamedColor;
  find: string;
  replace: string;

  constructor(items: ColoredTextFindReplaceItem[]) {

    const itemsCopy = items.map(r => new ColoredTextFindReplaceItem(r.find,r.replace, r.color)) ?? [];

    this.textItems = itemsCopy ?? [];
    this.colors = NamedColorList;

    // const maxIndex = this.colors.length - 1;
    // let nextIndex = this.textItems.length;
    // if (nextIndex > maxIndex) {
    //   nextIndex = (nextIndex%maxIndex)+1;
    // }
    const maxlength = this.colors.length;
    let nextlength = this.textItems.length+1;
    var nextIndex=nextlength-1;
    if (nextlength > maxlength) {
      var rem = (nextlength%maxlength);
      if(rem==0){
        nextIndex=maxlength-1;
      }
      else{
        nextIndex=rem-1;
      }
    }
    this.currentColor = this.colors[nextIndex];
  }
}

@Component({
    selector: 'app-find-replace-chooser-map-dialog-option',
    templateUrl: './find-replace-chooser-map-dialog-option.component.html',
    styleUrls: ['./find-replace-chooser-map-dialog-option.component.scss'],
    standalone: false
})
export class FindReplaceChooserMapDialogOptionComponent extends BaseComponent implements OnInit{
  private readonly destroyRef = inject(DestroyRef);
  title: string;
  fieldType: string="edit";// Possible values: 'edit', 'dropdown', 'autocomplete'. Default 'edit'
  labelFind: string;
  labelReplace: string;
  placeholderFind: string;
  placeholderReplace: string;
  validateboth: false;
  enterKeyPressCount: number = 0;  // Counter for Enter key presses
  isDuplicateRemoved: boolean=false;//Remove Duplicate field value. Default false
  canAddNewAutocomplete: boolean=false;//Can add new item in Autocomplete
  optionsFind: OptionItemDataType[]=[];//Option values for 'dropdown'and 'autocomplete'. Default []
  optionsReplace: OptionItemDataType[]=[];//Option values for 'dropdown'and 'autocomplete'. Default []
  optionsDropdown: string[]=[];//Option values for 'dropdown' list with default starting option[] as remove duplicate mean it nor show in the dropdown. Default []
  inputFindControl = new FormControl();
  inputReplaceControl = new FormControl();
  filteredOptionsFind!: Observable<string[]>;
  filteredOptionsReplace!: Observable<string[]>;
  disableAllNone: boolean=false;
  isDataTypeCheck: boolean=false;
  optionsRaw: string[]=[];//Option values for back up when remove duplicate retrieve
  inputFindControlList: FormControl[] = [];
  filteredOptionsFindList: Observable<string[]>[] = [];
  inputReplaceControlList: FormControl[] = [];
  filteredOptionsReplaceList: Observable<string[]>[] = [];

  viewModel: ViewModel;
  @ViewChild('textbox') textbox: ElementRef;
  @ViewChild('textboxmatform', { read: ElementRef }) textboxmatform: ElementRef;
  @ViewChild('textboxmatformreplace', { read: ElementRef }) textboxmatformreplace: ElementRef;
  duplicateWarningMessage = ''; // Message to show when duplicate is found
  isDuplicate = false; // Flag to enable/disable the tooltip
  @ViewChild('newFindTooltip') newFindTooltip: MatTooltip;
  @ViewChild('newReplaceTooltip') newReplaceTooltip: MatTooltip;
  @ViewChildren('findTooltip') findTooltips!: QueryList<MatTooltip>;
  @ViewChildren('replaceTooltip') replaceTooltips!: QueryList<MatTooltip>;
  @ViewChild('dialogRoot') dialogRoot!: ElementRef;
  constructor(
    private dialogRef: MatDialogRef<FindReplaceChooserMapDialogOptionComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData,
    errorLogger: ErrorReportingService,
     private keyboardService: KeyboardService,
    matDialog: MatDialog,private snackBar: MatSnackBar) {
      super(errorLogger, matDialog);
  }

  // @HostListener('document:keydown.escape')
  // onEscapePress() {
  //   this.cancel();
  // }
  
  async ngOnInit(): Promise<void> {
    this.title = this.dialogData.title;
    this.labelFind = this.dialogData.labelFind;
    this.labelReplace = this.dialogData.labelReplace;
    this.placeholderFind = this.dialogData.placeholderFind;
    this.placeholderReplace = this.dialogData.placeholderReplace;
    this.validateboth=this.dialogData.validateboth;
    this.viewModel = new ViewModel(this.dialogData.items);
    this.fieldType = this.dialogData.fieldType;
    this.isDuplicateRemoved=this.dialogData.isDuplicateRemoved;
    this.canAddNewAutocomplete=this.dialogData.canAddNewAutocomplete;
    this.optionsFind = this.dialogData.optionsFind;
    this.optionsReplace = this.dialogData.optionsReplace;
    this.isDataTypeCheck = this.dialogData.isDataTypeCheck;
    // Remove undefined values else it gives error
    // this.optionsFind = this.optionsFind.filter((opt): opt is string => opt !== undefined);
    // this.optionsDropdown=[...this.optionsFind];
    // this.optionsRaw=[...this.optionsFind];
    this.inputFindControlList = this.viewModel.textItems.map(() => new FormControl());
    this.inputReplaceControlList = this.viewModel.textItems.map(() => new FormControl());
    await this.allNoneCondition();
    // Set up the filtering logic
    if(this.fieldType=="autocomplete"){
      this.filteredOptionsFind = this.inputFindControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filterFind(value || ''))
      );
      this.filteredOptionsReplace = this.inputReplaceControl.valueChanges.pipe(
        startWith(''),
        map(value => this._filterReplace(value || ''))
      );
      //list
      this.filteredOptionsFindList = this.inputFindControlList.map((ctrl) =>
        ctrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filterFind(value || ''))
        )
      );
      
      this.filteredOptionsReplaceList = this.inputReplaceControlList.map((ctrl) =>
        ctrl.valueChanges.pipe(
          startWith(''),
          map(value => this._filterReplace(value || ''))
        )
      );
    }
    if(this.fieldType=="autocomplete" || this.fieldType=="dropdown"){
      if(this.isDuplicateRemoved){
        this.removeOptionDuplicate();
      }
    }
     this.keyboardService.onKey('Escape', () => {
    this.dialogRef.close();
  }, this.destroyRef);
  }

 ngAfterViewInit(): void {
    // Focus out from the textbox after view initialization
    if(this.fieldType!="dropdown"){
      this.textbox.nativeElement.blur();
    }
    this.keyboardService.onKey('Escape', () => {
    this.cancel();
  }, this.destroyRef);
 
  this.keyboardService.registerEnterToDelete(
    () => this.viewModel.textItems,
    (item) => this.deleteItem(item),
    '#add-input', // 🔥 fallback focus
    this.destroyRef
  );

  //  this.keyboardService.registerArrowNavigation(
  //   this.dialogRoot.nativeElement
  // );
  this.keyboardService.registerGlobalDoubleEnter(() => {
  this.save();
}, this.destroyRef);
  }
  
  save(): void {
    this.resetErrorState();
    var isValid=true;
    const findSet = new Map<string, { indices: number[], color: string }>();// Store indices and color of the first occurrence

    this.viewModel.textItems.forEach((item, index) => {
      // Check if find field is empty
      if(this.validateboth){
        if(item.find==null || item.find=="" || item.find.trim().length==0){
          isValid=false;
          this.applyErrorStateFind(index, 'Please enter a value or remove the row.');
          return;
        }
        if(item.replace==null || item.replace=="" || item.replace.trim().length==0){
          isValid=false;
          this.applyErrorStateFind(index, 'Please enter a value or remove the row.');
          return;
        }
      }else{
        if(item.find==null || item.find=="" || item.find.trim().length==0){
          if(item.replace==null || item.replace==undefined){
            isValid=false;
            this.applyErrorStateFind(index, 'Please enter a value or remove the row.');
            return;
          }else{
            item.find=="";
          }
        }
        else{
          if(item.replace==null || item.replace==undefined){
            item.replace="";// prevent undefined error
          }
        }
      }

      // Check for duplicate finds
      if (findSet.has(item.find)) {
        isValid = false;
        const { indices, color } = findSet.get(item.find);
        indices.push(index);
        findSet.set(item.find, { indices, color }); // Keep track of the same color for the duplicate entries
      } else {
        findSet.set(item.find, { indices: [index], color: item.color.color }); // Store index of first occurrence if unique
      }
      // 
      if (this.isDataTypeCheck){
        if(item.find==item.replace){
          isValid=false;
          this.applyErrorStateFind(index, 'Each Source <> Target Pair must not be same.');
          this.applyErrorStateReplace(index, 'Each Source <> Target Pair must not be same.');
        }
        var finddatatype=this.optionsFind.find(f=>f.text==item.find).dataType;
        var replacedatatype=this.optionsReplace.find(f=>f.text==item.replace).dataType;
        if(finddatatype!=replacedatatype){
          isValid=false;
          this.applyErrorStateFind(index, 'Each Source <> Target Pair must be of the same data type.');
          this.applyErrorStateReplace(index, 'Each Source <> Target Pair must be of the same data type.');
        }
      }
    });
    // Apply error states for each duplicate "Find" value
    findSet.forEach(({ indices, color }, findValue) => {
        if (indices.length > 1) { // Only apply error if there are duplicates
            indices.forEach(duplicateIndex => {
                this.applyErrorStateFind(duplicateIndex, `This value "${findValue}" is duplicated.`, color);
            });
        }
    });
    if(!isValid){
      //this.displayWarning("No entries can be empty, please enter values or remove the row(s).","Warning.");
      this.displayWarning("Some entries are invalid. Please fix them before saving.","Warning.");
      return;
    }
    //console.log("end item :");
    this.dialogRef.close({items: this.viewModel.textItems,eventname:'save'});
  }
  private applyErrorStateFind(index: number, message: string,color?:string): void {
    // Find the specific input element to add error styling
    const inputElement = document.getElementById(`findInput${index}`);
    if (inputElement) {
      inputElement.classList.add('mat-form-field-error'); // Add error CSS
      inputElement.style.color = '#000000';
      if(color){
        inputElement.style.backgroundColor = color;
      }else{
        inputElement.style.backgroundColor = "#f58484";
      }
    }
  
    const tooltip = this.findTooltips.toArray()[index];
    if (tooltip) {
      tooltip.message = message;
      tooltip.disabled = false;
    }
  }
  private applyErrorStateReplace(index: number, message: string,color?:string): void {
    // Find the specific input element to add error styling
    const inputElement = document.getElementById(`replaceInput${index}`);
    if (inputElement) {
      inputElement.classList.add('mat-form-field-error'); // Add error CSS
      inputElement.style.color = '#000000';
      if(color){
        inputElement.style.backgroundColor = color;
      }else{
        inputElement.style.backgroundColor = "#f58484";
      }
    }
  
    const tooltip = this.replaceTooltips.toArray()[index];
    if (tooltip) {
      tooltip.message = message;
      tooltip.disabled = false;
    }
  }
  // Resets error styles and tooltips for all input fields
  private resetErrorState(): void {
    this.viewModel.textItems.forEach((_, index) => {
        const inputElement = document.getElementById(`findInput${index}`);
        if (inputElement) {
            inputElement.classList.remove('mat-form-field-error'); // Remove error CSS
            inputElement.style.backgroundColor = ''; // Reset background color
            inputElement.style.color = '';
        }

        const tooltip = this.findTooltips.toArray()[index];
        if (tooltip) {
            tooltip.disabled = true; // Disable tooltip
        }

        const inputElementReplace = document.getElementById(`replaceInput${index}`);
        if (inputElementReplace) {
            inputElementReplace.classList.remove('mat-form-field-error'); // Remove error CSS
            inputElementReplace.style.backgroundColor = ''; // Reset background color
            inputElementReplace.style.color = '';
        }

        const tooltipReplace = this.replaceTooltips.toArray()[index];
        if (tooltipReplace) {
            tooltipReplace.disabled = true; // Disable tooltip
        }
    });
  }
  cancel(): void {
    this.dialogRef.close({items: this.viewModel.textItems,eventname:'cancel'});
  }

  deleteItem(item: ColoredTextFindReplaceItem): void {
    const index = this.viewModel.textItems.indexOf(item);
    this.viewModel.textItems.splice(index, 1);
    //this.textbox.nativeElement.focus();
    this.reassignColors();
  }
  addItem(): void {
    if(this.validateboth){
      if(this.viewModel.find==null || this.viewModel.find=="" || this.viewModel.find.trim().length==0){
        this.viewModel.find="";
        this.textboxmatform.nativeElement.classList.add('mat-form-field-invalid');
      }

      if(this.viewModel.replace==null || this.viewModel.replace=="" || this.viewModel.replace.trim().length==0){
        this.viewModel.replace="";
        this.textboxmatformreplace.nativeElement.classList.add('mat-form-field-invalid');
        this.enterKeyPressCount++;  // Increment Enter key press counter
        if (this.enterKeyPressCount >= 2) {
          this.save();
        }
        return;
      }
    }else{
      if(this.viewModel.find==null || this.viewModel.find=="" || this.viewModel.find.trim().length==0){
        this.viewModel.find="";
        if(this.viewModel.replace==null || this.viewModel.replace=="" || this.viewModel.replace.trim().length==0){
          this.textboxmatform.nativeElement.classList.add('mat-form-field-invalid');
          return;
        }else{
          console.log("this.viewModel.replace :",this.viewModel.replace);
          this.enterKeyPressCount++;  // Increment Enter key press counter
          if (this.enterKeyPressCount >= 2) {
            this.save();
          }
        }
      }
    }
    if (this.isDataTypeCheck){
        if(this.viewModel.find==this.viewModel.replace){
          this.textboxmatform.nativeElement.classList.add('mat-form-field-invalid');
          this.textboxmatformreplace.nativeElement.classList.add('mat-form-field-invalid');
          this.displayWarning("Each Source <> Target Pair must not be same","")
          return;
        }
        var finddatatype=this.optionsFind.find(f=>f.text==this.viewModel.find).dataType;
        var replacedatatype=this.optionsReplace.find(f=>f.text==this.viewModel.replace).dataType;
        if(finddatatype!=replacedatatype){
          this.textboxmatform.nativeElement.classList.add('mat-form-field-invalid');
          this.textboxmatformreplace.nativeElement.classList.add('mat-form-field-invalid');
          this.displayWarning("Each Source <> Target Pair must be of the same data type, please correct.  "+this.viewModel.find+" ("+finddatatype+")  "+this.viewModel.replace+" ("+replacedatatype+")","")
          return;
        }
      }
    // Reset error state if input is valid
    this.textboxmatform.nativeElement.classList.remove('mat-form-field-invalid');
    this.textboxmatformreplace.nativeElement.classList.remove('mat-form-field-invalid');
    this.enterKeyPressCount = 0;
    this.isDuplicate = false; // Reset duplicate flag
    this.newReplaceTooltip.hide(); // Hide tooltip if it was previously shown

    // Check if item already exists in textItems array
    const existingItem = this.viewModel.textItems.find(existing => existing.find === this.viewModel.find);
    if (existingItem) {
      // If item exists, show tooltip with warning message
      this.textboxmatform.nativeElement.classList.add('mat-form-field-invalid');
      this.duplicateWarningMessage = 'This Find string already exists.';
      // this.textboxmatformreplace.nativeElement.classList.add('mat-form-field-invalid');
      // this.duplicateWarningMessage = 'This string already exists.';
      this.isDuplicate = true; // Enable tooltip
      // Delay showing the tooltip briefly to ensure it renders
      setTimeout(() => {
        this.newReplaceTooltip.show();// Show the tooltip programmatically
      }, 100);

      return;
    }
    const item = new ColoredTextFindReplaceItem(this.viewModel.find,this.viewModel.replace, this.viewModel.currentColor);
    this.viewModel.textItems.push(item);

    const maxlength = this.viewModel.colors.length;
    let nextlength = this.viewModel.textItems.length+1;
    var nextIndex=nextlength-1;
    if (nextlength > maxlength) {
      var rem = (nextlength%maxlength);
      if(rem==0){
        nextIndex=maxlength-1;
      }
      else{
        nextIndex=rem-1;
      }
    }
    this.viewModel.currentColor = this.viewModel.colors[nextIndex];
    this.viewModel.find="";
    this.viewModel.replace="";
    this.textbox.nativeElement.focus();
    this.isDuplicate = false; // Disable tooltip after successful addition
    this.inputFindControlList.push(new FormControl());
    this.inputReplaceControlList.push(new FormControl());
    // Also re-init the filtered list Observables
    this.filteredOptionsFindList.push(
      this.inputFindControlList[this.inputFindControlList.length - 1].valueChanges.pipe(
        startWith(''),
        map(value => this._filterFind(value || ''))
      )
    );

    this.filteredOptionsReplaceList.push(
      this.inputReplaceControlList[this.inputReplaceControlList.length - 1].valueChanges.pipe(
        startWith(''),
        map(value => this._filterReplace(value || ''))
      )
    );
  }
  focusNext(nextIndex: number) {
    const nextInput = document.getElementById('findInput' + nextIndex);
    if (nextInput) {
      (nextInput as HTMLInputElement).focus();  // Focus on the next input
    }
  }
  // Method to hide tooltip when the input changes
  onInputChange(): void {
    // Hide the tooltip if the user starts typing
    if (this.newReplaceTooltip) {
      this.newReplaceTooltip.hide();
    }
    this.isDuplicate = false; // Reset the duplicate flag
  }
  reassignColors(): void {
    try{
      this.viewModel.textItems.forEach((item, i) => {
        item.color = NamedColorList[i % NamedColorList.length];
      });
      const nextIndex = this.viewModel.textItems.length;
      this.viewModel.currentColor = NamedColorList[nextIndex % NamedColorList.length];
    }catch (err) {
      console.log('Failed to reassignColors', err);
    }
  }
  async allNoneCondition():Promise<void>{
    const allNoneItem = this.viewModel.textItems.find(
      itm => itm.find === "All" || itm.find === "None"
    );
    if(allNoneItem){
      this.viewModel.textItems = [allNoneItem];
      this.disableAllNone=true;
      this.inputReplaceControl.disable();
    }else{
      this.disableAllNone=false;
      this.inputReplaceControl.enable();
    }
  }
  removeOptionDuplicate(): void {
    var removeList=this.viewModel.textItems.map(item => item.find);
    //this.optionsFind=this.optionsFind.filter(option => !removeList.includes(option));
  }
  // Filter method for autocomplete
  private _filterFind(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsFind.filter(option => option.text.toLowerCase().includes(filterValue)).map(itm=>itm.text);
  }
  private _filterReplace(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.optionsReplace.filter(option => option.text.toLowerCase().includes(filterValue)).map(itm=>itm.text);
  }
  validateSelection(): void {
    setTimeout(() => {
      const currentFindValue = this.inputFindControl.value;
      const currentReplaceValue = this.inputReplaceControl.value;
      if(!this.canAddNewAutocomplete){
        if (!this.optionsFind.map(op=>op.text).includes(currentFindValue)) {
          this.inputFindControl.setValue(''); // Clear the input if the value is invalid
          return;
        }
        if (!this.optionsReplace.map(op=>op.text).includes(currentReplaceValue)) {
          this.inputReplaceControl.setValue(''); // Clear the input if the value is invalid
          return;
        }
      }
      this.addItem();
    }, 500);
  }
  onKeyEnter() {
    const currentFindValue = this.inputFindControl.value;
    if(currentFindValue===""){
      this.enterKeyPressCount++;  // Increment Enter key press counter
        if (this.enterKeyPressCount >= 2) {
          this.save();
        }
    }
  }
  // drop(event: CdkDragDrop<any[]>) {
  //   moveItemInArray(this.viewModel.textItems, event.previousIndex, event.currentIndex);
  //   this.reassignColors(); // if order affects color
  // }
  drop(event: CdkDragDrop<any[]>) {

  if (event.previousIndex === event.currentIndex) {
    return;
  }

  // Move main data
  moveItemInArray(
    this.viewModel.textItems,
    event.previousIndex,
    event.currentIndex
  );

  // Move form controls
  moveItemInArray(
    this.inputFindControlList,
    event.previousIndex,
    event.currentIndex
  );

  moveItemInArray(
    this.inputReplaceControlList,
    event.previousIndex,
    event.currentIndex
  );

  // Move filtered observables
  moveItemInArray(
    this.filteredOptionsFindList,
    event.previousIndex,
    event.currentIndex
  );

  moveItemInArray(
    this.filteredOptionsReplaceList,
    event.previousIndex,
    event.currentIndex
  );

  this.reassignColors();
}

  async import(): Promise<void>{
    const dialogRef = this.matDialog.open(FileUploadDialogComponent, {
      width: '600px',
      height: '450px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        for (const item of result) {
          this.viewModel.find = item.find;        // or push into an array
          this.viewModel.replace = item.replace;
          await this.addItem();
          this.viewModel.find = "";
          this.viewModel.replace = "";
        }
      }
    });
  }
  async Export(): Promise<void>{
    const dialogRef = this.matDialog.open(DelimiterDialogComponent, {
      width: '350px',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(delimiter => {
      if (!delimiter) return; // Cancel pressed

      let delim = delimiter.trim();

      // Support \t ⇨ actual tab
      if (delim === "\\t") delim = "\t";

      const lines = this.viewModel.textItems.map(item =>
        `${item.find}${delim}${item.replace}`
      );

      const content = lines.join("\n");

      const blob = new Blob([content], { type: "text/plain;charset=utf-8" });
      const url = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "exported_items.txt";
      a.click();

      URL.revokeObjectURL(url);
    });
  }
  async CopyJSON(): Promise<void>{
    try {
      const jsonObject = this.viewModel.textItems.reduce((obj, item) => {
        obj[item.find] = item.replace;
        return obj;
      }, {} as Record<string, string>);
      
      const json = JSON.stringify(jsonObject, null, 2);
      await navigator.clipboard.writeText(json);
      this.snackBar.open("JSON Copied to Clipboard", 'Dismiss', {
          duration: 5000,
        });
    } catch (err) {
      this.displayError("Failed to copy JSON", "Error");
    }
  }
  async CopyText(): Promise<void>{
    try {
      const lines = this.viewModel.textItems
        .map(item => `${item.find}\t${item.replace}`)
        .join('\n');

      await navigator.clipboard.writeText(lines);

      this.snackBar.open("Tab-Delimited Text Copied to Clipboard", 'Dismiss', {
          duration: 5000,
        });
    } catch (err) {
      this.displayError("Failed to copy Text", "Error");
    }
  }
  async PasteJSON(): Promise<void>{
    const dialogRef = this.matDialog.open(JsonPasteDialogComponent, {
      width: '600px',
      height: '420px',
      disableClose: true,
      data: { inputType: 'json' }
    });

    dialogRef.afterClosed().subscribe(async result => {
      
      if (!result) return;

      let pairs: Array<{ find: string, replace: string }> = [];
      // CASE 1 → JSON OBJECT
      if (typeof result === 'object' && !Array.isArray(result)) {
        for (const [find, replace] of Object.entries(result)) {
          pairs.push({ find: find.trim(), replace: (replace as string).trim() });
        }
      }
      // Now add all items
      for (const item of pairs) {
        this.viewModel.find = item.find;
        this.viewModel.replace = item.replace;
        await this.addItem();
      }

      // Reset
      this.viewModel.find = "";
      this.viewModel.replace = "";
    });
  }
  async PasteText(): Promise<void>{
    const dialogRef = this.matDialog.open(JsonPasteDialogComponent, {
      width: '600px',
      height: '420px',
      disableClose: true,
      data: { inputType: 'text' }
    });

    dialogRef.afterClosed().subscribe(async result => {
      
      if (!result) return;

      let pairs: Array<{ find: string, replace: string }> = [];
      // CASE 2 → TEXT INPUT
      if (typeof result === 'string') {

        const lines = result
        .split(/\r?\n/)
        .filter(x => x.trim().length > 0); // only check, don’t modify

        for (const line of lines) {

          const delimiter =
            line.includes(',') ? ',' :
            line.includes('|') ? '|' :
            line.includes(';') ? ';' :
            line.includes('=') ? '=' :
            line.includes('\t') ? '\t' :
            (line.trim().split(/\s+/).length > 1 ? ' ' : null);

          //if (!delimiter) continue;

          let find = '';
          let replace = '';
          if (delimiter === null) {
            find = line.trim();
          }else if (delimiter === ' ') {
            const match = line.match(/^(\S+)\s*(.*)$/);
            if (!match) continue;

            find = match[1];
            replace = match[2] ?? ''; // ✅ blank allowed
          } else {
            const parts = line.split(delimiter);
            find = parts[0]?.trim();
            replace = parts.slice(1).join(delimiter); // no trim → allow blank
          }

          pairs.push({ find, replace });
        }
      }
      // Now add all items
      for (const item of pairs) {
        this.viewModel.find = item.find;
        this.viewModel.replace = item.replace;
        await this.addItem();
      }

      // Reset
      this.viewModel.find = "";
      this.viewModel.replace = "";
    });
  }
  async DeleteAll(): Promise<void>{
    this.viewModel.textItems=[];
    this.reassignColors();
  }
}
